import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import { InputBody } from './InputBody.js';
import { Wrapper, WrapperLabel, OptionalLabel, WrapperInput } from './styles.js';
import Caption from '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const Input = forwardRef((_a, ref) => {
    var { label, optionalLabel = '(opcional)', helperText, feedback, showFeedbackIcon = true, suffix: Suffix, prefix: Prefix, isLoading, disabled, readOnly, id, required, margin, marginTop, marginBottom, marginRight, marginLeft, marginHorizontal, marginVertical, m, mt, mr, mb, ml, mx, my, w, width, maxW, maxWidth, minW, minWidth } = _a, props = __rest(_a, ["label", "optionalLabel", "helperText", "feedback", "showFeedbackIcon", "suffix", "prefix", "isLoading", "disabled", "readOnly", "id", "required", "margin", "marginTop", "marginBottom", "marginRight", "marginLeft", "marginHorizontal", "marginVertical", "m", "mt", "mr", "mb", "ml", "mx", "my", "w", "width", "maxW", "maxWidth", "minW", "minWidth"]);
    return (React.createElement(Wrapper, Object.assign({}, {
        margin,
        marginTop,
        marginBottom,
        marginRight,
        marginLeft,
        marginHorizontal,
        marginVertical,
        m,
        mt,
        mr,
        mb,
        ml,
        mx,
        my,
    }),
        label && (React.createElement(WrapperLabel, null,
            React.createElement(ParagraphMd, { bold: true, as: "label", htmlFor: id }, label),
            !required && React.createElement(OptionalLabel, null, optionalLabel))),
        React.createElement(WrapperInput, Object.assign({ feedback: feedback, disabled: disabled, readOnly: readOnly, isLoading: isLoading }, { w, width, maxW, maxWidth, minW, minWidth }),
            React.createElement(InputBody, Object.assign({ feedback: feedback, showFeedbackIcon: showFeedbackIcon, disabled: disabled, readOnly: readOnly, isLoading: isLoading, required: required, id: id, helperText: helperText, prefix: Prefix, suffix: Suffix, ref: ref }, props))),
        helperText && React.createElement(Caption, null, helperText)));
});
Input.displayName = 'Input';

export { Input };
